import React from "react";
import { TabsContent } from "@/components/ui/tabs";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { z } from "zod";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Form } from "@/components/ui/form";
import FormInputField from "@/components/lib/from-input-field";

const dateSchema = z.object({
  date: z.string().min(1, "Date is required"),
});

function BusinessLocationTabs() {
  const form = useForm({
    resolver: zodResolver(dateSchema),
    defaultValues: {
      date: "",
    },
  });

  return (
    <TabsContent value="business-location">
      <Card className="mt-5 bg-cblack5">
        <CardHeader>
          <h2 className="text-lg">Business & Location Details</h2>
        </CardHeader>
        <CardContent>
          <Form {...form}>
            <form className="flex flex-col gap-6">
              <FormInputField
                name="tradingName"
                style="bg-cblack7"
                placeholder={"Enter Trading Name"}
                form={form}
                type="text"
                label={"Trading Name"}
              />
              <div className="flex items-center w-full gap-5 flex-col md:flex-row">
                <div className="w-[240px]">
                  {" "}
                  <FormInputField
                    name="legalEntity"
                    style="bg-cblack7"
                    placeholder={"Select legal entity"}
                    form={form}
                    type="select"
                    selectOption={[
                      {
                        label: "Pvt. LTD",
                        value: "pvtLtd",
                      },
                      { label: "Sole Trader", value: "soloTrader" },
                      { label: "Partnership", value: "partnership" },
                    ]}
                    label={"Business Type"}
                  />
                </div>
                <div className="flex-1  w-full">
                  <FormInputField
                    name="legalName"
                    style="bg-cblack7 w-full"
                    placeholder={"Enter legal name"}
                    form={form}
                    type="text"
                    label={"Legal Name"}
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                <FormInputField
                  name="registeredAddress"
                  style="bg-cblack7"
                  placeholder={"Enter registered address"}
                  form={form}
                  type="text"
                  label={"Registered Address"}
                />
                <FormInputField
                  name="city"
                  style="bg-cblack7"
                  placeholder={"Enter Email City"}
                  form={form}
                  type="text"
                  label={"City"}
                />
                <FormInputField
                  name="post-code"
                  style="bg-cblack7"
                  placeholder={"Enter Post code"}
                  form={form}
                  type="text"
                  label={"Post Code"}
                />
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                <FormInputField
                  name="trading-location"
                  style="bg-cblack7"
                  placeholder={"Enter Trading/Location Address"}
                  form={form}
                  type="text"
                  label={"Trading/Location Address"}
                />
                <FormInputField
                  name="city-2"
                  style="bg-cblack7"
                  placeholder={"Enter Email City"}
                  form={form}
                  type="text"
                  label={"City"}
                />
                <FormInputField
                  name="post-code2"
                  style="bg-cblack7"
                  placeholder={"Enter Post code"}
                  form={form}
                  type="text"
                  label={"Post Code"}
                />
              </div>
              <FormInputField
                name="sameOutlet"
                style="bg-cblack7"
                placeholder={"Same as outlet 1 address"}
                form={form}
                type="checkbox"
                label={"Same as outlet 1 address"}
              />

              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                <FormInputField
                  name="phone"
                  style="bg-cblack7"
                  placeholder={"Enter phone number"}
                  form={form}
                  type="text"
                  label={"Phone Number"}
                />
                <FormInputField
                  name="mobile"
                  style="bg-cblack7"
                  placeholder={"Enter Mobile Number"}
                  form={form}
                  type="text"
                  label={"Mobile Number"}
                />
                <FormInputField
                  name="email"
                  style="bg-cblack7"
                  placeholder={"Enter Email Address"}
                  form={form}
                  type="text"
                  label={"Email Address"}
                />
              </div>
              <div className="flex items-center w-full gap-5 flex-col md:flex-row">
                <div className="w-[240px]">
                  <FormInputField
                    name="numberOfOutlet"
                    style="bg-cblack7"
                    placeholder={"2"}
                    form={form}
                    type="text"
                    disabled
                    label={"Number of Outlet"}
                  />
                </div>
                <div className="flex-1  w-full">
                  <FormInputField
                    name="legalName"
                    style="bg-cblack7 w-full"
                    placeholder={"Enter legal name"}
                    form={form}
                    type="text"
                    label={"Legal Name"}
                  />
                </div>
              </div>

              {/* here is add dynamic input add */}
              <div></div>
            </form>
          </Form>
        </CardContent>
      </Card>
    </TabsContent>
  );
}

export default BusinessLocationTabs;
